import { useState, useEffect, useMemo } from 'react';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { Well, WellItem, WellLabel, WellBigNumber } from 'foundations-components/transitional/components/Well';
import { getJourneySummaryMetrics } from 'reporting-ui-components/lib/getJourneySummaryMetrics';
import { useJourneyReport } from 'reporting-ui-components/components/journey/useJourneyReport';
import useJourneyReportOptions from 'reporting-ui-components/components/journey/internal/useJourneyReportOptions';
import { isNoDataState } from 'reporting-snowflake/funnel/utils/journeyUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const INITIAL_REPORT_OPTIONS = {};
const IS_DRILLDOWN = false;
const JourneyReportKPIPreview = ({
  report
}) => {
  const [reportResolve, setReportResolve] = useState(null);
  const reportObj = useMemo(() => {
    return report.toJS();
  }, [report]);
  const {
    reportOptions
  } = useJourneyReportOptions(INITIAL_REPORT_OPTIONS, IS_DRILLDOWN);
  const {
    visualization,
    datamap,
    settled,
    error,
    report: journeyReport
  } = useJourneyReport(reportObj, reportOptions);
  useEffect(() => {
    const resolvedReport = {
      resolveDatamap: datamap,
      resolveJourneyReport: journeyReport,
      resolveError: error,
      hasData: !isNoDataState(visualization, IS_DRILLDOWN)
    };
    if (settled && visualization) {
      setReportResolve(resolvedReport);
    }
  }, [settled, error, visualization, datamap, journeyReport]);
  if (!reportResolve) {
    return /*#__PURE__*/_jsx(LoadingSpinner, {
      grow: true
    });
  }
  const metrics = getJourneySummaryMetrics(reportResolve);
  const previewMetric = metrics === null || metrics === void 0 ? void 0 : metrics[0];
  if (!previewMetric) {
    throw new Error('Failed to load journey summary metric');
  }

  // TODO: add date inlineLabel tag
  return /*#__PURE__*/_jsx(Well, {
    children: /*#__PURE__*/_jsxs(WellItem, {
      children: [/*#__PURE__*/_jsx(WellLabel, {
        children: previewMetric.label
      }), /*#__PURE__*/_jsx(WellBigNumber, {
        children: previewMetric.value
      })]
    }, previewMetric.key)
  });
};
export default JourneyReportKPIPreview;